import { Flex, Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { FC, useMemo } from "react";

import { PrimaryText } from "@/shared/ui/Typography";

import {
    StyledTACollapse,
    StyledTACollapseWrapper,
    StyledTAColumnNameText,
    StyledTATableWrapper,
    StyledTATotalSumText,
    StyledTAValueText,
} from "./Styled";

interface ITotalAccordion {
    opened: number;
    closed: number;
}

export const TotalAccordion: FC<ITotalAccordion> = ({ opened, closed }) => {
    const data = useMemo(() => {
        return [{ key: "total", open: opened, closed, total: opened + closed }];
    }, [opened, closed]);
    const columns: ColumnsType<(typeof data)[0]> = [
        {
            title: <StyledTAColumnNameText>Відкриті</StyledTAColumnNameText>,
            dataIndex: "open",
            key: "open",
            align: "right",
            render: (value: number) => (
                <StyledTAValueText>
                    {value.toLocaleString("uk-UA", {
                        minimumFractionDigits: 2,
                    })}{" "}
                    ₴
                </StyledTAValueText>
            ),
        },
        {
            title: <StyledTAColumnNameText>Закриті</StyledTAColumnNameText>,
            dataIndex: "closed",
            key: "closed",
            align: "right",
            render: (value: number) => (
                <StyledTAValueText>
                    {value.toLocaleString("uk-UA", {
                        minimumFractionDigits: 2,
                    })}{" "}
                    ₴
                </StyledTAValueText>
            ),
        },
        {
            title: <StyledTAColumnNameText>Разом</StyledTAColumnNameText>,
            dataIndex: "total",
            key: "total",
            align: "right",
            render: (value: number) => (
                <StyledTAValueText>
                    {value.toLocaleString("uk-UA", {
                        minimumFractionDigits: 2,
                    })}{" "}
                    ₴
                </StyledTAValueText>
            ),
        },
    ];

    const totalSum = data.find((item) => item.key === "total")?.total || 0;

    const collapseItems = [
        {
            key: "1",
            label: (
                <Flex
                    justify="space-between"
                    align="center"
                    style={{ width: "100%" }}
                >
                    <PrimaryText
                        fontSize={14}
                        fontWeight="400"
                        lineHeight="140%"
                    >
                        Загальна сума
                    </PrimaryText>
                    <StyledTATotalSumText>
                        {totalSum.toLocaleString("uk-UA", {
                            minimumFractionDigits: 2,
                        })}{" "}
                        грн.
                    </StyledTATotalSumText>
                </Flex>
            ),
            children: (
                <StyledTATableWrapper>
                    <Table
                        columns={columns}
                        dataSource={data}
                        pagination={false}
                        bordered
                        rowClassName={() => "custom-row"}
                    />
                </StyledTATableWrapper>
            ),
        },
    ];

    return (
        <StyledTACollapseWrapper>
            <StyledTACollapse items={collapseItems} />
        </StyledTACollapseWrapper>
    );
};
